import * as React from "react";
import { Provider } from 'react-redux'
import { RouterProvider } from 'react-router-dom'
import store from './store'
import { router } from './router'
import RootSnackbar from './components/root/RootSnackbar'
import RootMessageAlert from './components/root/RootMessageAlert'
import RootLoadingMask from './components/root/RootLoadingMask'


export default function App() {
  return (
    <Provider store={store}>
      <RootLoadingMask />
      <RootSnackbar />
      <RootMessageAlert />
      <RouterProvider router={router} basename="/MANAGE/" fallbackElement={<p>Loading...</p>} />
    </Provider>
  )
}

